import { addressFormat } from './address-format';

export const FR = {
  validator: null,
  addressFormat,
};
